import { World } from "./testCase";
import BuyTestCase from "./buyTestCase";
class BuyNoArgumentRoot extends World {
    constructor(testCase) {
        super(testCase);
        this._buyTestCase = testCase;
    }
    buyHat() {
        this.log("Buy a hat");
        this._buyTestCase.buyHat(1);
    }
    buyMitten() {
        this.log("Buy a mitten");
        this._buyTestCase.buyMitten(1);
    }
}
export class BuyNoArgumentTestCase extends BuyTestCase {
    //sceneNode is shared.
    createRoot() {
        return new BuyNoArgumentRoot(this);
    }
    //styleSheet is shared
    createElement(document) {
        let template = document.createElement("template");
        let html = `<div class="buy-container">
      <div class="buy-grid">
        <div class="buy-center"><button class="buy_hat w-full btn-darkBackHigh">Buy Hat</button></div>
        <br/>
        <div class="buy-center"><button class="buy_mitten w-full btn-darkBackHigh">Buy Mitten</button></div>
      </div>
    </div>`;
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        template.content.firstElementChild
            .getElementsByClassName("buy_hat")[0]
            .addEventListener("click", () => {
            this.log("Buy a hat");
            this.buyHat(1);
            this.queueEvaluate();
        });
        template.content.firstElementChild
            .getElementsByClassName("buy_mitten")[0]
            .addEventListener("click", () => {
            this.log("Buy a mitten");
            this.buyMitten(1);
            this.queueEvaluate();
        });
        return template.content.firstElementChild;
    }
}
